export default "__VITE_ASSET__DxTI$l6$__"